import { APP } from 'src/Configs/App'

export const SPOTIFY_RECONNECT_SUCCEEDED_PARAM = 'succeeded'
export const SPOTIFY_RECONNECT_ERROR_PARAM = 'error'
export const SPOTIFY_RECONNECT_DISPLAY_NAME_PARAM = 'spotifyDisplayName'
export const SPOTIFY_WRONG_ACCOUNT_ERROR = 'wrong_spotify_account'
export const SPOTIFY_RECONNECT_FLAG = 'spotifyReconnect'

const RECONNECT_RESULT_PARAMS = [
  SPOTIFY_RECONNECT_SUCCEEDED_PARAM,
  SPOTIFY_RECONNECT_ERROR_PARAM,
  SPOTIFY_RECONNECT_DISPLAY_NAME_PARAM,
  SPOTIFY_RECONNECT_FLAG,
]

export interface InitiateSpotifyReconnectParams {
  userId: number
}

const buildReturnUrl = (): string => {
  const { origin, pathname, search, hash } = window.location
  const returnSearch = new URLSearchParams(search)

  RECONNECT_RESULT_PARAMS.forEach((param) => returnSearch.delete(param))
  returnSearch.set(SPOTIFY_RECONNECT_FLAG, '1')

  return `${origin}${pathname}?${returnSearch.toString()}${hash}`
}

export const initiateSpotifyReconnect = ({
  userId,
}: InitiateSpotifyReconnectParams): void => {
  const returnUrl = buildReturnUrl()
  const params = new URLSearchParams({
    userId: String(userId),
    successUrl: returnUrl,
    cancelUrl: returnUrl,
  })

  window.location.href = `${APP.TIKTOK_SERVER}/public/auth/spotify/reconnect?${params.toString()}`
}
